import React from 'react';
import SortingTitle from './SortingTitle';
import Card from '../../share/cards/Card';
import sort1 from '../../../Assets/Image/png/sort1.png';
import sort2 from '../../../Assets/Image/png/sort2.png';
import { ReactComponent as IconStar } from '../../../Assets/Image/svg/star.svg';

const sortInfos = [
	{
		sortImg: sort1,
		title: 'طراحی تبلیغات دیجیتالی برای سازمان های دولتی',
		place: 'دانشگاه صنعتی اصفهان',
		time: 'کمپ سه روزه',
		price: '1,500,000 تومان',
	},
	{
		sortImg: sort2,
		title: 'طراحی تبلیغات دیجیتالی برای سازمان های دولتی',
		place: 'دانشگاه صنعتی اصفهان',
		time: 'کمپ سه روزه',
		price: '1,500,000 تومان',
	},
];

function Sorting(props) {
	return (
		<div>
			<SortingTitle />
			<div className='grid  gap-[3.6rem] mb-[5rem] bootcamp__cards'>
				{sortInfos.map((sortinfo, key) => {
					return [
						<Card key={key} className='overflow-hidden '>
							<img src={sortinfo.sortImg} className='w-full mb-[1rem]' />
							<div className='px-6 pb-[2rem]'>
								<div className='flex flex-col items-start justify-start mb-[1.8rem]'>
									<h2
										onClick={props.onclick}
										className='cursor-pointer text-balck text-xs font-bold leading-[2.4rem] text-right mb-[1.1rem] '
									>
										{' '}
										{sortinfo.title}
									</h2>
									<span className='text-light-prim text-[1.1rem] leading-[1.5rem] mb-[1.3rem]'>
										{sortinfo.place}
									</span>
									<span className='text-light-prim  text-[1rem] leading-[1.2rem] text-right'>
										زمان بوت کمپ:{sortinfo.time}
									</span>
								</div>
								<div className='flex flex-col items-end'>
									{/* rating */}
									<div className='flex items-center'>
										<em className='text-gray-light2 text-[1rem] '>
											(23)
										</em>
										<div className='sort__rating'>
											{Array.from(Array(5), (_, key) => {
												return <IconStar key={key} />;
											})}
										</div>

										<span className='sort__count--sum text-[1.1rem]'>
											(2.8)
										</span>
									</div>
									<span className='text-[1.3rem]'>
										{sortinfo.price}{' '}
									</span>
								</div>
							</div>
						</Card>,
					];
				})}
			</div>
		</div>
	);
}

export default Sorting;
